module.exports = __webpack_public_path__ + "img/category-tube.f5ac984d.svg";